<template>
  <v-dialog
    v-model="dialogDashboardProjet"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <Loading :value="loading"></Loading>
    <v-card tile>
      <v-toolbar card dark color="primary">
        <v-toolbar-title>TABLEAU DE BORD PROJET</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click.native="closeDialog()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-layout row mt-2 ml-1 mb-3>
        <v-flex sm3 mr-2 class="elevation-3">
          <v-card>
            <v-toolbar color="cyan" dark>
              <v-toolbar-title>Informations Projet</v-toolbar-title>
            </v-toolbar>

            <v-list subheader two-line>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>{{
                    detailProjet.libelle
                  }}</v-list-tile-title>
                  <v-list-tile-sub-title>Libelle</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider></v-divider>

              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>{{ detailProjet.chef }}</v-list-tile-title>
                  <v-list-tile-sub-title
                    >Responsable projet</v-list-tile-sub-title
                  >
                </v-list-tile-content>
              </v-list-tile>
              <v-divider></v-divider>

              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title
                    >{{ detailProjet.dateD }} --{{ detailProjet.dateF }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title
                    >Période d'exécution</v-list-tile-sub-title
                  >
                </v-list-tile-content>
              </v-list-tile>
              <v-divider></v-divider>
            </v-list>
          </v-card>
        </v-flex>

        <v-flex sm10>
          <WidgetProjet :projet="detailProjet"></WidgetProjet>
        </v-flex>
      </v-layout>

      <!-- TAB Projet -->
      <v-layout row>
        <v-flex sm12 ml-1 mr-1 mt-1>
          <v-card>
            <el-tabs
              v-model="onglet"
              type="border-card"
              @tab-click="handleTabClick(onglet)"
            >
              <el-tab-pane label="Chantiers">
                <!-- LISTE CHANTIERS-->
                <ChantierIndex  :commis="false" :listeChantiers="chantiers"></ChantierIndex>
                <!-- LISTE CHANTIERS-->
                <br />
              </el-tab-pane>
              <el-tab-pane label="Besoins Matériels/Matériaux">
                <!-- LISTE CHANTIERS-->
                <besoinResponsable
                  :listeBesoins="besoins"
                  :idresponsable="detailProjet.idChef"
                  @reloadBesoins="loadBesoinAvalider()"
                ></besoinResponsable>
                <!-- LISTE CHANTIERS-->
              </el-tab-pane>
              <el-tab-pane label="Rapport Journaliers">
                <!-- LISTE DES RAPPORT TRAVAUX D'UN PROJET -->
                <ListeRapportTrx
                  :type="2"
                  :commis="false"
                  :listeRapportTrx="listeRapports"
                  @reloadListeRapport="loadRapportProjet()"
                >
                </ListeRapportTrx>
                <!-- LISTE DES RAPPORT TRAVAUX D'UN PROJET -->
              </el-tab-pane>
              <el-tab-pane label="Reserve Travaux">
                <!-- RESULATS RESERVE TRAVAUX -->
                <!-- LISTE DES RAPPORT TRAVAUX D'UN PROJET -->
                <ListeReserve
                  :type="2"
                  :listeReserveTrx="listeReserves"
                  @reloadListeReserve="loadReserves()"
                >
                </ListeReserve>
                <!-- LISTE DES RAPPORT TRAVAUX D'UN PROJET -->
                <br />
              </el-tab-pane>
            </el-tabs>
          </v-card>
        </v-flex>
      </v-layout>
      <!--FIN  TAB Projet -->
    </v-card>
  </v-dialog>
</template>

<script>
import Loading from "@/components/Loading";
import ChantierIndex from "@/components/boardChantier/Chantier_index";
import besoinResponsable from "@/components/besoin/besoinResponsable";
import ListeRapportTrx from "@/components/rapport/ListeRapportTrx";
import ListeReserve from "@/components/rapport/ListeReserve";
import WidgetProjet from "@/components/boardProjet/widgetProjet";
export default {
  components: {
    Loading,
    ChantierIndex,
    besoinResponsable,
    ListeRapportTrx,
    ListeReserve,
    WidgetProjet
  },
  name: "DashboardProjet",
  props: {
    show: {
      type: Boolean
    },
    detailProjet: {
      type: Object
    }
  },
  data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      dialogDashboardProjet: false,
      loading: false,
      onglet: "0",

      //ONGLET CHANTIERS
      chantiers: [],

      //ONGLET besoins
      besoins: [],

      //ONGLET RAPPORS
      listeRapports: [],

      //ONGLET RESERVE
      listeReserves: []
    };
  },
  methods: {
    //ONGLET CHANTIER
    loadChantier() {
      this.loading = true;
      let url =
        this.domaine + "chantier/liste/" + this.detailProjet.id + "/projet";
      this.$http.get(url).then(
        response => {
          this.chantiers = response.body.chantier;
          this.loading = false;
        },
        error => {
          this.loading = false;
          this.$message.error("Echec lors du chargement des chantiers");
        }
      );
    },
    loadBesoinAvalider() {
      this.loading = true;
      let url = this.domaine + "besoin/projet/" + this.detailProjet.id;
      this.$http.get(url).then(response => {
        this.besoins = response.body.besoins;
        this.loading = false;
      });
    },
    handleTabClick(tab) {
      switch (tab) {
        case "0":
          if (this.chantiers.length == 0) {
            this.loadChantier();
          }

          break;
        case "1":
          if (this.besoins.length == 0) {
            this.loadBesoinAvalider();
          }
          break;
        case "2":
          if (this.listeRapports.length == 0) {
            this.loadRapportProjet();
          }
          break;
        case "3":
          if (this.listeReserves.length == 0) {
            this.loadReserves();
          }
          break;

        default:
          break;
      }
    },
    //onglet rapports
    loadRapportProjet() {
      this.loading = true;
      let url = this.domaine + "journal/projet/" + this.detailProjet.id;
      this.$http.get(url).then(
        response => {
          this.listeRapports = response.body.journaux;
          this.loading = false;
        },
        error => {
          this.loading = false;
          this.$message.error("Echec lors du chargement des Journaux");
        }
      );
    },

    //ONGLET RESERVE
    loadReserves() {
      this.loading = true;
      let url = this.domaine + "reserve/projet/" + this.detailProjet.id;
      this.$http.get(url).then(
        response => {
          this.listeReserves = response.body.reserves;
          this.loading = false;
        },
        error => {
          this.loading = false;
          this.$message.error("Echec lors du chargement des reserves");
        }
      );
    },

    closeDialog() {
      this.besoins.splice(0);
      this.chantiers.splice(0);
      this.$emit("close");
    }
  },

  watch: {
    show: function(newValue, oldvalue) {
      this.dialogDashboardProjet = newValue;
      if (newValue == true) {
        this.onglet = "0";
        this.loadChantier();
        //this.loadBesoinAvalider()
      }
    }
  }
};
</script>

<style>
.list {
  height: auto !important;
}
.list__tile__sub-title {
  height: 300px;
}
.list__tile__title {
  height: 45px;
}
.list__tile__content,
.list__tile__action {
  height: 73%;
}
</style>



// WEBPACK FOOTER //
// src/components/boardProjet/dashboardProjet.vue